export function normalizeSize(size: number, decimals = 2): number {
  if (Number.isInteger(size)) return size;

  const formatted = parseFloat(size.toFixed(decimals));

  return Number.isInteger(formatted) ? Math.trunc(formatted) : formatted;
}
